// Editor slice initial state src/store/editor/initial.js
import { display_object_schema } from '~/schemas/display_object_schema'

const brushProps = display_object_schema.definitions.brush.properties

export default {
	current_fill: '#ff0000',
	current_stroke: '',
	current_tool: 'move',
	current_brush_width: brushProps.widthGrowth.initial,
	current_brush_cap: brushProps.strokeCap.initial,
	current_smoothness: brushProps.smoothness.initial,
	current_min_width: brushProps.minWidth.initial,
	current_width_profile: brushProps.widthProfile.initial,
	current_attraction: 8,
	rope_mode: false,
	rope_bend: 0.5,
	current_eraser_width: 20,
	current_eraser_smoothness: 50,
	expanded_layer_ids: [],
	is_masking: false,
	is_transforming: false,
	editing_group_stack: [],
	last_fill_id: null,
}
